import { NavLink } from "react-router-dom";
import "@components/Locations/location-navigation.scss";
import { getValue } from "@utils/lodash";

export default function AdminNavigation(props: any) {
  return (
    <div className="common-sticky-header">
      <section className="inner-page-navigation-with-back-cta-buttons position-relative">
        <div className="container-fluid  d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <NavLink to="/admin/users">
              <img
                src="/images/back-link.svg"
                className="img-fluid"
                height={24}
                width={24}
              />
            </NavLink>
            <div className="inner-page-navigation-with-back-cta-button__header">
              {/* <h4 className="inner-page-navigation-with-back-cta-button__header-title">
                User Profile
              </h4> */}
            </div>
            <ul className="inner-page-navigation-with-back-cta-buttons__navigation d-inline-flex position-absolute">
            <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
              <NavLink
                to="#0"
                className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
              >
                User Details
              </NavLink>
            </li>
            {/* {!props.id && (
              <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                <NavLink
                  to={`/location/detail`}
                  className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                >
                  Location
                </NavLink>
              </li>
            )}
            {props.id && props.id !== "undefined" && (
              <>
                <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                  <NavLink
                    to={`/location/detail/${props.id}`}
                    className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                  >
                    Location
                  </NavLink>
                </li>
                <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                  <NavLink
                    to={`/location/map-vendor/${props.id}`}
                    className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                  >
                    Map To Vendors
                  </NavLink>
                </li>
                <li className="inner-page-navigation-with-back-cta-buttons__nav-list-item">
                  <NavLink
                    to={`/location/functions/${props.id}`}
                    className="inner-page-navigation-with-back-cta-buttons__nav-list-item-link"
                  >
                    Function
                  </NavLink>
                </li>
              </>
            )} */}
          </ul>
          </div>
          

          {getValue(props, `id`, "")
            ? getValue(props, `permissions`, []).includes("update") && (
                <div>
                  <NavLink to={props.url}>
                    <button className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3">
                      Cancel
                    </button>
                  </NavLink>
                  {props.isLoading ? (
                    <button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
                      Please wait...
                    </button>
                  ) : (
                    <button
                      className={`ascent-button ascent-button--header-buttons ascent-button--${
                        !props.isChanged ? "secondary" : "primary"
                      }`}
                      onClick={props.handleSubmit}
                      disabled={props.isChanged}
                    >
                      Save
                    </button>
                  )}
                </div>
              )
            : getValue(props, `permissions`, []).includes("create") && (
                <div>
                  <NavLink to={props.url}>
                    <button className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3">
                      Cancel
                    </button>
                  </NavLink>
                  {props.isLoading ? (
                    <button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
                      Please wait...
                    </button>
                  ) : (
                    <button
                      className={`ascent-button ascent-button--header-buttons ascent-button--${
                        !props.isChanged ? "secondary" : "primary"
                      }`}
                      onClick={props.handleSubmit}
                      disabled={props.isChanged}
                    >
                      Save
                    </button>
                  )}
                </div>
              )}
          {/* {getValue(props, `permissions`, []).includes("update") ||
          getValue(props, `permissions`, []).includes("create") ? (
            <div>
              <NavLink to={props.url}>
                <button className="ascent-button ascent-button--header-buttons ascent-button--primary mx-3">
                  Cancel
                </button>
              </NavLink>
              {props.isLoading ? (
                <button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
                  Please wait...
                </button>
              ) : (
                <button
                  className={`ascent-button ascent-button--header-buttons ascent-button--${
                    !props.isChanged ? "secondary" : "primary"
                  }`}
                  onClick={props.handleSubmit}
                  disabled={props.isChanged}
                >
                  Save
                </button>
              )}
            </div>
          ) : (
            <button
              className={`ascent-button ascent-button--header-buttons ascent-button-secondary`}
            >
              .
            </button>
          )} */}
        </div>
      </section>
    </div>
  );
}
